export const TAB_STATES = {
  UNREAD: 'UNREAD',
  ALL: 'ALL',
  TRASH: 'TRASH'
};
export const {
  UNREAD,
  ALL,
  TRASH
} = TAB_STATES;
export const TabStateToSidebarTabName = {
  ALL: 'ALL',
  TRASH: 'DELETED',
  UNREAD: 'UNREAD'
};

/**
 * The maximum number of supported notifications that can be checked/unchecked
 * in the sidebar list. This mirrors the number the backend limits us to when
 * providing a list of specific notification ids to bulk endpoints.
 */
export const SPECIFIC_NOTIFICATION_SELECTION_LIMIT = 100;